import React, { Component } from 'react';
// import cx from 'classnames';

export default class Header extends Component {
	constructor(props) {
		super(props);

		this.state = { menuIsActive: false };

		this.toggleMenu = this.toggleMenu.bind(this);
	}

	toggleMenu() {
		this.setState({
			menuIsActive: !this.state.menuIsActive
		});
	}

	render() {
		// const { menuIsActive } = this.state;
		//
		// {/*const styles = {*/}
		// 	{/*button: {*/}
		// 		{/*marginLeft: "auto"*/}
		// 	{/*}*/}
		// {/*};*/}
		// //
		// // const navbarMenuClass = cx({
		// // 	'sense-menu-items': true,
		// // 	'is-active': menuIsActive
		// // });
const styleheader={
	display: "inline-block"
}
		return (
			<div className="header" style={styleheader}>
				<img src="/Includes/Images/top-logo-new.png" alt="" className="img-fluid" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Header.jsx